import {
  FINANCE_ITEM_STATUSES,
  type FinanceItemStatuses
} from "../../../../constants/finance-item-constants.ts"
import { RESPONSIBLE_TYPES } from "../../../../constants/responsible-type-constants.ts"

// Mirrors FinancialTransactionItemCreateSerializer.create: a new line is
// stamped New, except a Reimbursement, which has to count immediately and so
// keeps the Planned/Pending status implied by is_planned.
export const statusOnCreate = (
  responsibleType: number | null | undefined,
  isPlanned: boolean | null | undefined
): FinanceItemStatuses => {
  if (responsibleType !== RESPONSIBLE_TYPES.REIMBURSEMENT) {
    return FINANCE_ITEM_STATUSES.NEW
  }
  return isPlanned
    ? FINANCE_ITEM_STATUSES.PLANNED
    : FINANCE_ITEM_STATUSES.PENDING
}
